import GetRequest from "../utilities/api/get-request";
import PostRequest from "../utilities/api/post-request";

class Orders {
    /*
       |--------------------------------------------------------------------------
       | Get Orders (faire)
       |--------------------------------------------------------------------------
       |
       */

    static async get(filterParameters = {}) {
        const path = '/api/orders';

        return await GetRequest(path, filterParameters);
    }

    /*
    |--------------------------------------------------------------------------
    | Import Orders
    |--------------------------------------------------------------------------
    |
    */

    static async import(data = {}) {
        const path = '/api/orders/import';

        return await PostRequest(path, data);
    }

    /*
    |--------------------------------------------------------------------------
    | Send order to Wix
    |--------------------------------------------------------------------------
    |
    */

    static async sendToWix(orderId: string) {
        const path = `/api/orders/${orderId}/export`;

        return await PostRequest(path);
    }

}

export default Orders